export default __webpack_public_path__ + "static/KeywordResearch_01_01-7875f47df52d474f0bde4f6c09556630.png";